(() => {
  const boot = () => {
    const dock = document.querySelector('[data-nana-bottom-dock]');
    if (!dock || dock.dataset.bound === 'true') return;
    dock.dataset.bound = 'true';
    const html = document.documentElement;
    html.classList.add('nana-dock-enabled');
    const viewport = window.visualViewport;
    let baseline = viewport ? viewport.height : window.innerHeight;
    const editing = () => {
      const active = document.activeElement;
      return Boolean(active && active.matches('input:not([type=button]):not([type=submit]):not([type=checkbox]):not([type=radio]),textarea,[contenteditable=true]'));
    };
    const update = () => {
      const height = viewport ? viewport.height : window.innerHeight;
      if (!editing()) baseline = height;
      html.classList.toggle('nana-dock-keyboard', Boolean(editing() && baseline - height > 140));
    };
    const measure = () => {
      if (getComputedStyle(dock).display !== 'none') html.style.setProperty('--nana-dock-height', Math.ceil(dock.getBoundingClientRect().height) + 'px');
    };
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', () => queueMicrotask(update));
    window.addEventListener('resize', () => { update(); measure(); });
    if (viewport) viewport.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(dock);
    measure(); update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
